<div class="browser-top">
  <p class="browser-header mode-label">Google Sheet</p>
  <a class="browser-link" [href]="helpLink" target="_blank"> Learn how to prep your Sheet data </a>
</div>
<div class="browser">
  <ng-container *ngIf="showBrowser; else noBrowserTemplate">
    <capra-search-input
      class="search-input"
      size="regular"
      placeholder="Search for a Spreadsheet"
      [autofocus]="true"
      [text]="searchText"
      (textChange)="searchTextChange.emit($event)"
    ></capra-search-input>
    <div class="sheets" *ngIf="spreadsheets.length; else noSearchResultsTemplate">
      <div class="spreadsheets">
        <div class="table-container">
          <table cdk-table [dataSource]="spreadsheets" [trackBy]="trackByFn" [fixedLayout]="true">
            <ng-container cdkColumnDef="name">
              <th cdk-header-cell *cdkHeaderCellDef class="spreadsheet-name-column mode-th">Spreadsheet name</th>
              <td cdk-cell *cdkCellDef="let element" class="spreadsheet-name-column">
                <div class="sheet-name">
                  <capra-icon class="sheet-name-icon" icon="illo-gsheets-file"></capra-icon>
                  <span class="sheet-name-text">
                    {{ element.name }}
                  </span>
                </div>
              </td>
            </ng-container>
            <ng-container cdkColumnDef="owner">
              <th cdk-header-cell *cdkHeaderCellDef class="owner-column mode-th">Owned by</th>
              <td cdk-cell *cdkCellDef="let element" class="owner-column">
                {{ element?.owner ?? '--' }}
              </td>
            </ng-container>
            <ng-container cdkColumnDef="lastOpened">
              <th cdk-header-cell *cdkHeaderCellDef class="last-opened-column mode-th">Last opened by me</th>
              <td cdk-cell *cdkCellDef="let element" class="last-opened-column">
                {{ (element?.lastOpened | date) ?? '--' }}
              </td>
            </ng-container>
            <tr cdk-header-row *cdkHeaderRowDef="spreadsheetColumns; sticky: true"></tr>
            <tr
              cdk-row
              *cdkRowDef="let row; columns: spreadsheetColumns"
              [class.selected]="selectedSpreadsheetRow.isSelected(row)"
              (click)="selectSpreadsheet(row)"
            ></tr>
          </table>
          <button
            *ngIf="moreSheetsAvailable"
            class="load-more"
            type="button"
            [disabled]="!loadMoreSheetsEnabled"
            (click)="showMoreSpreadsheets()"
          >
            <capra-icon
              class="load-more-icon"
              [class.ready]="loadMoreSheetsEnabled"
              [class.disabled]="!loadMoreSheetsEnabled"
              [icon]="loadMoreSheetsEnabled ? 'icon-back' : 'icon-refresh'"
            ></capra-icon>
            {{ loadMoreSheetsEnabled ? 'Show more Spreadsheets' : 'Loading more Spreadsheets...' }}
          </button>
        </div>
      </div>
      <div class="worksheets">
        <ul *ngIf="worksheetsLoading; else worksheetsTemplate" class="worksheets-loader">
          <h3 class="worksheets-loader-header mode-th">Worksheet name</h3>
          <li></li>
          <li></li>
          <li></li>
        </ul>
        <ng-template #worksheetsTemplate>
          <div *ngIf="selectedSpreadsheet; else noWorksheetsTemplate" class="table-container">
            <table cdk-table [dataSource]="worksheets" [trackBy]="trackByFn" [fixedLayout]="true">
              <ng-container cdkColumnDef="name">
                <th cdk-header-cell *cdkHeaderCellDef class="worksheet-name-column mode-th">Worksheet name</th>
                <td cdk-cell *cdkCellDef="let element" class="worksheet-name-column">
                  <div class="sheet-name">
                    <span class="sheet-name-text">
                      {{ element.name }}
                    </span>
                  </div>
                </td>
              </ng-container>
              <tr cdk-header-row *cdkHeaderRowDef="worksheetColumns; sticky: true"></tr>
              <tr
                cdk-row
                *cdkRowDef="let row; columns: worksheetColumns"
                [class.selected]="selectedWorksheetRow.isSelected(row)"
                (click)="selectWorksheet(row)"
              ></tr>
            </table>
          </div>
          <ng-template #noWorksheetsTemplate>
            <div class="no-worksheets">Select a Spreadsheet to see its Worksheet tabs</div>
          </ng-template>
        </ng-template>
      </div>
    </div>
    <ng-template #noSearchResultsTemplate>
      <div class="no-sheets">
        <capra-icon
          [icon]="isAnalystStudio ? 'illo-generic-empty-state' : 'illo-air-ballon'"
          width="72px"
          height="72px"
        ></capra-icon>
        <h3 class="header">No Google Sheets match the search</h3>
        <p class="message">
          Make sure the spelling is correct and the Spreadsheet you're searching for has been shared with you
        </p>
      </div>
    </ng-template>
  </ng-container>

  <ng-template #noBrowserTemplate>
    <div class="no-sheets">
      <capra-icon
        [icon]="isAnalystStudio ? 'illo-generic-empty-state' : 'illo-air-ballon'"
        width="72px"
        height="72px"
      ></capra-icon>
      <h3 class="header">No Google Sheets to display</h3>
      <p class="message">
        Make sure you're connected to the right Google Account and have access to one or more Google Sheets
      </p>
    </div>
  </ng-template>
</div>
